import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { store } from '../../store/store.js';
import { launchElearning } from '../../store/elearning/elearning.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-elearning-dialog.js';
import '../shared/sdb-player-overlay-element.js';

@customElement('sdb-embedded-elearning-dialog')
class SdbEmbeddedElearningDialog extends EmbeddedHost(LitElement) {

    @property({ type: Boolean })
    accessor transparent;

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            <sdb-player-overlay-element id="sdb-elearning-dialog">
                <sdb-elearning-dialog
                    ?transparent=${this.transparent}>
                </sdb-elearning-dialog>
            </sdb-player-overlay-element>
        `;
    }

    open(item) {
        store.dispatch(launchElearning({ item }));
    }
}
